// extracted by mini-css-extract-plugin
export default {"container":"XCBt3v","title":"ImuzhW qRatTb mz-home-header","cover":"LZRLBu Riqxa6"};